/**
 * Created By Elia Rohana on 1/20/19
 */
import { initialState } from '../state';
import { BpmnProcessCreatorActionTypes, BpmnProcessErrorActions } from '../actions';

export function bpmnXmlGenerationError(state = initialState.bpmnXmlGenerationError, action: BpmnProcessErrorActions): string {
    switch (action.type) {
        case BpmnProcessCreatorActionTypes.GENERATE_BPMN_XML_FAILURE: {
            return  action.payload.error;
        }
        default: {
            return state;
        }
    }
}
